import React from 'react';
import { useTranslation } from 'react-i18next';

export function DPA() {
  const { t } = useTranslation();

  // Pour l'annexe 2, créer un tableau des mesures techniques
  const technicalMeasures = Array.from({ length: 14 }, (_, i) => i + 1);

  return (
    <div className="min-h-screen bg-white dark:bg-black dark:from-black dark:to-black pt-20 pb-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-8">
          {t('DPA.title')}
        </h1>
        
        <div className="prose dark:prose-invert max-w-none">
          {/* Introduction */}
          <section className="mb-8">
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              {t('DPA.introduction')}
            </p>
          </section>

          {/* Section 1: Définitions */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              {t('DPA.subtile1.title')}
            </h2>
            {['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'].map((letter) => (
              <div key={letter} className="mb-4">
                <p className="text-gray-700 dark:text-gray-300">
                  {t(`DPA.subtitle1.part${letter}`)}
                </p>
              </div>
            ))}
          </section>

          {/* Section 2: Conditions */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              {t('DPA.subtitle2.title')}
            </h2>
            {['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'].map((letter) => (
              <div key={letter} className="mb-4">
                <p className="text-gray-700 dark:text-gray-300">
                  {t(`DPA.subtitle2.part${letter}`)}
                </p>
              </div>
            ))}
          </section>

          {/* Section 3: Transferts restreints */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              {t('DPA.subtitle3.title')}
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              {t('DPA.subtitle3.intro')}
            </p>
            {['A', 'B', 'C', 'D'].map((letter) => (
              <div key={letter} className="mb-4">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                  {t(`DPA.subtitle3.part${letter}.title`)}
                </h3>
                <p className="text-gray-700 dark:text-gray-300">
                  {t(`DPA.subtitle3.part${letter}.content`)}
                </p>
              </div>
            ))}
          </section>

          {/* Section 4: LGPD */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              {t('DPA.subtitle4.title')}
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              {t('DPA.subtitle4.content')}
            </p>
          </section>

          {/* Section 5: États-Unis */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              {t('DPA.subtitle5.title')}
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              {t('DPA.subtitle5.content')}
            </p>
          </section>

          {/* Annexe 1 */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              {t('DPA.appendix1.title')}
            </h2>
            
            {/* Section A */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                {t('DPA.appendix1.sectionA.title')}
              </h3>
              <div className="mb-4">
                <h4 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                  {t('DPA.appendix1.sectionA.exporter.title')}
                </h4>
                <p className="text-gray-700 dark:text-gray-300">
                  {t('DPA.appendix1.sectionA.exporter.content')}
                </p>
              </div>
              <div className="mb-4">
                <h4 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                  {t('DPA.appendix1.sectionA.importer.title')}
                </h4>
                <p className="text-gray-700 dark:text-gray-300">
                  {t('DPA.appendix1.sectionA.importer.content')}
                </p>
              </div>
            </div>

            {/* Section B */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                {t('DPA.appendix1.sectionB.title')}
              </h3>
              <p className="text-gray-700 dark:text-gray-300 mb-2">{t('DPA.appendix1.sectionB.categories')}</p>
              <p className="text-gray-700 dark:text-gray-300 mb-2">{t('DPA.appendix1.sectionB.dataTypes')}</p>
              <p className="text-gray-700 dark:text-gray-300 mb-2">{t('DPA.appendix1.sectionB.sensitiveData')}</p>
              <p className="text-gray-700 dark:text-gray-300 mb-2">{t('DPA.appendix1.sectionB.frequency')}</p>
              <p className="text-gray-700 dark:text-gray-300 mb-2">{t('DPA.appendix1.sectionB.nature')}</p>
              <p className="text-gray-700 dark:text-gray-300">{t('DPA.appendix1.sectionB.retention')}</p>
            </div>

            {/* Section C */}
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                {t('DPA.appendix1.sectionC.title')}
              </h3>
              <p className="text-gray-700 dark:text-gray-300">
                {t('DPA.appendix1.sectionC.content')}
              </p>
            </div>
          </section>

          {/* Annexe 2 */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
              {t('DPA.appendix2.title')}
            </h2>
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
              {t('DPA.appendix2.subtitle')}
            </h3>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              {t('DPA.appendix2.intro')}
            </p>
            {technicalMeasures.map((number) => (
              <li key={number} className="text-gray-700 dark:text-gray-300 mb-2">
                <u>{t(`DPA.appendix2.measures.${number}`)}</u>
              </li>
            ))}
          </section>
        </div>
      </div>
    </div>
  );
}